import DOMService from './DOMService';
const views = [
    {
        name: 'tiles',
        label: 'tx_zigrealestate.list_view_image',
        icon: 'apps',
    },
    {
        name: 'list',
        label: 'tx_zigrealestate.list_view_list',
        icon: 'list',
    },
    {
        name: 'map',
        label: 'tx_zigrealestate.list_view_map',
        icon: 'location_on',
    },
];
const ViewService = {
    getAll: () => {
        return views;
    },
    setRegularWidth: () => {
        DOMService.replaceClass('zds-container-fluid', 'zds-container');
        DOMService.setDisplayById('footer', 'block');
        DOMService.setOrRemoveStylePropertyBySelector('#breadcrumb-wrapper .default-content', 'margin-left', '0px');
        DOMService.setAttributeOnElementBySelector('full-width', 'false', 'zds-navigation');
        DOMService.setAttributeOnElementBySelector('full-width', 'false', 'zds-super-navigation');
    },
    setFullWidth: () => {
        DOMService.replaceClass('zds-container', 'zds-container-fluid');
        DOMService.setDisplayById('footer', 'none');
        DOMService.setOrRemoveStylePropertyBySelector('#breadcrumb-wrapper .default-content', 'margin-left', '0px');
        DOMService.setAttributeOnElementBySelector('full-width', 'true', 'zds-navigation');
        DOMService.setAttributeOnElementBySelector('full-width', 'true', 'zds-super-navigation');
    },
};
export default ViewService;
